// see https://redux.js.org/tutorials/quick-start
import { configureStore, createSlice } from '@reduxjs/toolkit'
import logger from 'redux-logger';
import {
  ROWS_PER_PAGE,
  no_filters
} from './utilities.js';

const getPageData = state => {

  let pageData
  if (!no_filters({ 'gene': state.gene, 'clinical_significance': state.clinicalSignificance })) {
    const startIndex = state.currentPage * ROWS_PER_PAGE
    const endIndex = startIndex + ROWS_PER_PAGE
    pageData = state.data.slice(startIndex, endIndex)
  } else {
    pageData = state.data
  }
  return pageData
}

export const clinvarDataSlice = createSlice({
  name: 'clinvarData',
  initialState: {
    data: [],
    pageData: [],
    gene: 'no_filter',
    clinicalSignificance: 'no_filter',
    totalRows: 0,
    currentPage: 0,
  },
  reducers: {
    load: (state, action) => {
      state.data = action.payload
      state.currentPage = 0
      state.pageData = getPageData(state)
    },
    setGene: (state, action) => {
      state.gene = action.payload
    },
    setClinicalSignificance: (state, action) => {
      state.clinicalSignificance = action.payload
    },
    setTotalRows: (state, action) => {
      state.totalRows = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
      state.pageData = getPageData(state)
    }
  }
})

const store = configureStore({
  reducer: {
    clinvarData: clinvarDataSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
})

export const {
  load,
  setGene,
  setClinicalSignificance,
  setTotalRows,
  setCurrentPage,
} = clinvarDataSlice.actions

export default store
